import { MultiSelect } from '@mantine/core';
import type { GetInputPropsReturnType } from '@mantine/form';
import { i18nKeys, useTranslation } from 'locales';
import type { LightUser } from 'shared/hooks/use-load-light-users';

type AdditionalAssigneesSelectProps = GetInputPropsReturnType & {
  users: LightUser[];
  primaryUserId: string | undefined;
};

export const AdditionalAssigneesSelect = ({
  users,
  primaryUserId,
  ...inputProps
}: AdditionalAssigneesSelectProps) => {
  const { t } = useTranslation();

  return (
    <MultiSelect
      label={t(i18nKeys.TASK.ATTRIBUTES.ADDITIONAL_ASSIGNEES)}
      placeholder={t(i18nKeys.TASK.ATTRIBUTES.ADDITIONAL_ASSIGNEES_PLACEHOLDER)}
      data={users
        .filter(user => user.id.toString() !== primaryUserId)
        .map(user => ({ label: user.name.full, value: user.id.toString() }))}
      searchable
      {...inputProps}
    />
  );
};
